import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { AdminPortalApiService } from '../../misc/services/adminPortalApi.service';
import { SystemConfigurationsMobileConfigResponse } from '../../typings/system-configurations';
import * as fromConfigActions from '../actions/config.actions';

@Injectable()
export class ConfigEffects {
  private actions$ = inject(Actions);
  private adminPortalApiService = inject(AdminPortalApiService);

  loadConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromConfigActions.loadConfig),
      mergeMap(() =>
        this.adminPortalApiService.sendRequest('GET', `/v2/system-configurations/mobile`).pipe(
          map((data: SystemConfigurationsMobileConfigResponse) =>
            fromConfigActions.loadConfigSuccess({ payload: data })
          ),
          catchError((error: HttpErrorResponse) =>
            of(
              fromConfigActions.loadConfigFailure({
                payload: {
                  error: `Failed to connect to our services (${error.message})`
                }
              })
            )
          )
        )
      )
    )
  );
}
